module.exports = __webpack_public_path__ + "static/5.2_ancient_egypt-eeb5841410ce5792d987657620650a7c.pdf";